// components
import { ChannelCard, VideoCard, Loader } from './';

const Videos = ({ videos, gridMode }) => {
  if (!videos.length) return <Loader />;

  return (
    <div className={`grid grid-cols-1 ${!gridMode && 'md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4'} gap-4 mt-4`}>
      {videos.map((item, idx) => (
        <div key={idx}>
          {item.id.videoId && <VideoCard video={item} />}
          {item.id.playlistId && <VideoCard video={item} />}
          {item.id.channelId && <ChannelCard channelDetail={item} />}
        </div>
      ))}
    </div>
  );
};

export default Videos;
